import Vue from 'vue'
import Vuex from 'vuex'
import ls from './LStorage'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        token: false,
        userId: null,
        type: null,//1-普通用户，2-销售，3-医生
        userInfo: {},
        faceId: null,//上传的脸部id
        tongueId: null,//上传的舌头id
        answer: null,//问诊答案
        faceFile: null,//面诊图片
        tongueFile: null,//舌诊图片
        testUser: {},//当前测试者的信息
        isWechat: 0,//0-不是
        isNewtell: true,
        sendCard: null,//赠送卡片
        saleQrId: '',//销售的二维码id
        defaulteImg: null,//默认头像
        pushMessageNum: 0,//推送消息计数
        messageNum: 0,//接收消息计数
        messageMyNum: 0,//自己发送的消息计数
        messageData: {},//接收消息data
        chatThireId: "", //发送消息时对方的id
        isBind: false,
        isTeam: true,
        isShowPublish: true,
        isShow: true,
        isShowt: false,
        isShowo: true,
        isShowf: true,
        isNewCard: false,
        wsLogin: false, //soket连接状态
        archiveReport: {}, //当前选择的报告详情
        feedquestion: {},//帮助问题获取
        weekuser: {},//周报用户
        teamId: null,//拼团id
        orderId: null,//订单id
        index: 0,//1电话，0图文
        auth: false,
    },
    mutations: {
        // 修改token
        setToken(state, bool) {
            state.token = bool;
            ls.setItem('token', bool);
        },
        //授权管理
        setAuth(state, bool) {
            state.auth = bool;
            ls.setItem('auth', bool)
        },
        //修改userId
        setUserId(state, id) {
            state.userId = id;
            ls.setItem('userId', id);
        },
        //修改type
        setType(state, val) {
            state.type = val;
            ls.setItem('type', val);
        },
        //修改用户信息
        setUserInfo(state, info) {
            state.userInfo = info;
            ls.setItem('userInfo', info);
        },
        //修改某一项用户信息
        setUserInfoSingle(state, key, value) {
            state.userInfo[key] = value;
            ls.setItemChild('userInfo', key, value);
        },
        //修改脸部id
        setFaceId(state, id) {
            state.faceId = id;
            ls.setItem('faceId', id);
        },
        //修改舌头id
        setTongueId(state, id) {
            state.tongueId = id;
            ls.setItem('tongueId', id);
        },
        //修改问诊答案
        setAnswer(state, answer) {
            state.answer = answer;
            ls.setItem('answer', answer);
        },
        //修改面诊图片
        setFaceFile(state, file) {
            state.faceFile = file;
        },
        //修改舌诊图片
        setTongueFile(state, file) {
            state.tongueFile = file;
        },
        //修改当前测试者的信息
        setTestUser(state, info) {
            state.testUser = info;
            ls.setItem('testUser', info);
        },
        //是否绑定
        setIsBind(state, info) {
            state.isBind = info;
            ls.setItem('isBind', info);
        },
        //是否显示规则
        setIsTeam(state, info) {
            state.isTeam = info;
            ls.setItem('isTeam', info);
        },
        //是否有新人卡
        setIsNewCard(state, info) {
            state.isNewCard = info;
            ls.setItem('isNewCard', info);
        },
        //获取帮助问题
        setFeed(state, info) {
            state.feedquestion = info;
            ls.setItem('feedquestion', info);
        },
        //赠送卡片
        setSendCard(state, info) {
            state.sendCard = info;
            ls.setItem('sendCard', info);
        },
        //关闭不显示新人卡提示
        setisShowPublish(state, value) {
            state.isShowPublish = value

        },
        //关闭不显示团队add
        setisShowt(state, value) {
            state.isShowt = value
            ls.setItem('isShowt', value);
        },
        //关闭不显示团队rule
        setisShowo(state, value) {
            state.isShowo = value
            ls.setItem('isShowo', value);
        },
        //关闭不显示团队rule
        setisShowf(state, value) {
            state.isShowf = value
            ls.setItem('isShowf', value);
        },
        //关闭不显示电话遮盖层
        setisShow(state, value) {
            state.isShow = value
            ls.setItem('isShow', value);
        },
        //我的咨询
        setIndex(state, value) {
            state.index = value
        },
        //是否首次进入健康咨询
        setIsNewtell(state, value) {
            state.isNewtell = value
        },
        setIsWeChat(state, value) {
            state.isWeChat = value;
        },
        setSaleQrId(state, value) {
            state.saleQrId = value;
            ls.setItem('saleQrId', value);
        },
        setDefaulteImg(state, value) {
            state.defaulteImg = value;
        },
        setPushMessageNum(state) {
            state.pushMessageNum++;
        },
        setMessageNum(state) {
            state.messageNum++;
        },
        setMessageMyNum(state) {
            state.messageMyNum++;
        },
        setMessageData(state, value) {
            state.messageData = value;
        },
        setChatThireId(state, value) {
            state.chatThireId = value;
        },
        setWsLogin(state, value) {
            state.wsLogin = value;
        },
        setArchiveReport(state, value) {
            state.archiveReport = value;
        },
        //修改用户信息
        setWeekUser(state, info) {
            state.weekuser = info;
            ls.setItem('weekuser', info);
        },
        //拼团id
        setTeamId(state, value) {
            state.teamId = value;
            ls.setItem('teamId', value);
        },
        //订单id
        setOrderId(state, value) {
            state.orderId = value;
            ls.setItem('orderId', value);
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js